var ProductAlternativesComponent = Vue.component('product-alternatives', {
    props: {
        'productId': Number,
        'lazyLoad': {
            'type': Boolean,
            'required': false,
            'default': true
        }
    },
    data: function () {
        return {
            alternatives: [],
            loaded: false
        };
    },
    created: function() {
        if (!this.lazyLoad) {
            this.loadAlternatives();
        }
    },
    methods:{
        loadAlternatives: function () {
            this.fetch('post', 'rshop-api/products/alternatives', { product_id: this.productId }, function (response) {
                this.alternatives = response.result.alternatives;
                this.loaded = true;

                rEvent.dispatch('ProductAlternatives.loaded');
            }.bind(this));
        }
    },
    computed: {
        empty: function() {
            return this.alternatives.length == 0;
        }
    }
});